var map = {
	"./bfs/app/shared/object-collection/shared/badges/my-dspace-status-badge/my-dspace-status-badge.component": [
		88545,
		"src_themes_bfs_app_shared_object-collection_shared_badges_my-dspace-status-badge_my-dspace-st-c65770"
	],
	"./custom/app/shared/object-collection/shared/badges/my-dspace-status-badge/my-dspace-status-badge.component": [
		67635,
		"src_themes_custom_app_shared_object-collection_shared_badges_my-dspace-status-badge_my-dspace-ffcbf3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87596;
module.exports = webpackAsyncContext;